/// <reference types="@angular/localize" />

import { CSP_NONCE, enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { Configuration, EnvConfigurationService } from '@services/env/env-configuration.service';
import { AppModule } from './app/app.module';

document.addEventListener('DOMContentLoaded', () => {
    // We designed the app so the same Angular app build can be used on many environments, only differing by configuration parameters provided in runtime.
    // However, it requires fetching those parameters very early in the startup process, even before Angular initializes:
    // - config.json is a static file baked in at deploy time (per-environment build/deploy pipeline).
    // - public-configuration is a live backend endpoint, so values sourced from Azure App Configuration/Key Vault secrets
    //   (e.g. the dynamic application name) can change without requiring a frontend redeploy.
    Promise.all([
        fetch('assets/config/config.json?version=20261105115936', { method: 'get' }).then((response) =>
            response.json()
        ),
        // Non-critical: fall back to a default rather than blocking app startup if this call fails.
        fetch('api/public-configuration', { method: 'get' })
            .then((response) => response.json())
            .catch((err) => {
                console.error(
                    'Failed to fetch public configuration from the backend. Using default application name.',
                    err
                );
                return {
                    applicationName: 'Trial Companion',
                    applicationNamePP: 'Trial Companion',
                } as Partial<Configuration>;
            }),
    ])
        .then(([envConfig, publicConfig]: [Configuration, Partial<Configuration>]) => {
            Object.assign(envConfig, publicConfig);

            if (envConfig.baseUrl.includes('localhost')) {
                envConfig.nonce = 'localhost';
            } else {
                let splitedVersion = envConfig.hashVersion.split('.');
                envConfig.nonce = splitedVersion[splitedVersion.length - 1];
            }

            EnvConfigurationService.setConfiguration(envConfig);

            if (envConfig.production) {
                enableProdMode();
            }

            platformBrowser([{ provide: CSP_NONCE, useValue: envConfig.nonce }])
                .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
                .catch((err) => console.error(err));
        })
        .catch((err) => {
            console.error(`Failed to fetch/parse configuration for the current environment. Application cannot start.`);
            console.error(err);
        });
});
